export var baseCommon = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-04-25 12:48:59',
    type: 'LOAN',
};
export var loanCommon = {
    id: 53,
    limitId: 18,
    amount: 150000,
    currency: 'PLN',
    period: 12,
    pricing: 17.5,
    loanRepaymentPrice: 13.93,
    name: 'LOAN_ADVANCE',
    iban: 'PL80109013040000000131651320',
    createdAt: '2024-11-19 09:19:44',
    provider: 'pragma',
    stage: 9,
    providerRequest: 'gotNotification',
    sms: [],
    loanRepaymentAccounts: [263534],
    previousStage: 2,
    documents: [
        {
            url: 'http://fso.loantest.qa.pragmago.tech/api/partner/company/PL7743262787/document/3ef0ef64-4d2f-4d12-bf89-8f836511da9b',
            type: 'pragma',
        },
    ],
    loanAmountChange: false,
};
export var limitCommon = {
    id: 1721296939,
    preLimitId: 1732011441,
    min: 3000,
    max: 15330,
    used: 15330,
    currency: 'PLN',
    provider: 'test-provider',
    availableLimitRevenueRate: [
        {
            period: 12,
            pricing: 30,
            loanRepaymentPrice: 3.6,
            amountMin: 10000,
            amountMax: 20000,
        },
        {
            period: 6,
            pricing: 30,
            loanRepaymentPrice: 3.6,
            amountMin: 10000,
            amountMax: 20000,
        },
    ],
    minMaxDifference: false,
    available: 15330,
};
export var documentsCommon = [
    {
        url: 'http://fso.loantest.qa.pragmago.tech/api/partner/company/PL7743262787/document/3ef0ef64-4d2f-4d12-bf89-8f836511da9b',
        type: 'pragma',
    },
];
export var valueCommon = {
    amount: 15330,
    currency: 'PLN',
};
